module.exports = __webpack_public_path__ + "static/img/android-chrome-192x192.622017a0.png";